import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';

export function initPhotoSwipeGallery(gallerySelector) {
    const lightbox = new PhotoSwipeLightbox({
        gallery: gallerySelector,
        children: 'a[data-pswp-width]',
        pswpModule: PhotoSwipe,
        wheelToZoom: true,
        pinchToClose: false,
        closeOnVerticalDrag: true,
        bgOpacity: 0.9,
        showHideAnimationType: 'zoom',
        initialZoomLevel: 0.5,
        secondaryZoomLevel: 1,
        maxZoomLevel: 2,
    });


    // Add simple caption
    lightbox.on('uiRegister', function() {
        // Custom caption with instructions
        lightbox.pswp.ui.registerElement({
            name: 'custom-caption',
            order: 9,
            isButton: false,
            appendTo: 'root',
            html: '<div class="pswp__custom-caption">Pinch to zoom • Double tap to zoom • Swipe to close</div>',
            onInit: (el, pswp) => {
                el.style.cssText = `
                    position: absolute;
                    bottom: 20px;
                    left: 50%;
                    transform: translateX(-50%);
                    color: white;
                    background: rgba(0,0,0,0.6);
                    padding: 8px 16px;
                    border-radius: 20px;
                    font-size: 14px;
                    text-align: center;
                    z-index: 10000;
                    pointer-events: none;
                `;
                
                // Hide caption after 3 seconds
                setTimeout(() => {
                    el.style.opacity = '0';
                    el.style.transition = 'opacity 0.3s ease';
                }, 3000);
            }
        });
    });

    // Prevent default link behavior
    lightbox.on('beforeOpen', () => {
        // Disable page scroll
        document.body.style.overflow = 'hidden';
    });

    lightbox.on('destroy', () => {
        // Re-enable page scroll
        document.body.style.overflow = '';
    });

    lightbox.init();
    
    return lightbox;
}